var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { technologies } from '../common/siteData';
import theme from '../common/theme';
var StyledProject = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n\n  /* @media screen and (min-width: ", ") { */\n  /* width: calc(50% - 1rem); */\n  /* } */\n\n  @media screen and (min-width: ", ") {\n    width: calc(50% - 2rem);\n  }\n\n  cursor: pointer;\n  margin-bottom: 4rem;\n\n  h3 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n"], ["\n  display: block;\n  width: 100%;\n\n  /* @media screen and (min-width: ", ") { */\n  /* width: calc(50% - 1rem); */\n  /* } */\n\n  @media screen and (min-width: ", ") {\n    width: calc(50% - 2rem);\n  }\n\n  cursor: pointer;\n  margin-bottom: 4rem;\n\n  h3 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n"])), theme.breakpoints.s, theme.breakpoints.m);
var Background = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: -120px;\n  background-color: #444;\n  background-size: cover;\n  background-position: center;\n  z-index: -1;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: -120px;\n  background-color: #444;\n  background-size: cover;\n  background-position: center;\n  z-index: -1;\n"])));
var Image = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 1rem;\n  height: 120px;\n  box-shadow: inset 0 4px 12px rgba(10, 20, 40, 0.04);\n  overflow: hidden;\n  position: relative;\n\n  @media screen and (min-width: 720px) {\n    border-radius: 2px;\n  }\n"], ["\n  margin-bottom: 1rem;\n  height: 120px;\n  box-shadow: inset 0 4px 12px rgba(10, 20, 40, 0.04);\n  overflow: hidden;\n  position: relative;\n\n  @media screen and (min-width: 720px) {\n    border-radius: 2px;\n  }\n"])));
var ProjectText = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var Description = styled.p(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin: 0.5em 0;\n"], ["\n  margin: 0.5em 0;\n"])));
var TagList = styled.ul(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  line-height: 1.5;\n"], ["\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  line-height: 1.5;\n"])));
var TagLabel = styled.li(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: inline-block;\n  margin-right: 1ch;\n  font-size: 14px;\n  font-weight: 700;\n"], ["\n  display: inline-block;\n  margin-right: 1ch;\n  font-size: 14px;\n  font-weight: 700;\n"])));
var Tag = styled(TagLabel)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  :before {\n    content: '';\n    display: inline-block;\n    position: relative;\n    height: 0.3rem;\n    width: 0.3rem;\n    margin-right: 0.6ch;\n    top: -0.2rem;\n    border-radius: 40%;\n    background-color: ", ";\n\n    box-shadow: 0 5px 15px rgba(11, 33, 22, 0.1);\n  }\n"], ["\n  :before {\n    content: '';\n    display: inline-block;\n    position: relative;\n    height: 0.3rem;\n    width: 0.3rem;\n    margin-right: 0.6ch;\n    top: -0.2rem;\n    border-radius: 40%;\n    background-color: ", ";\n\n    box-shadow: 0 5px 15px rgba(11, 33, 22, 0.1);\n  }\n"])), function (props) { return props.background || '#ccc'; });
var Project = function (_a) {
    var className = _a.className, data = _a.data, scrollTop = _a.scrollTop;
    var _b = useState({
        mx: 0,
        my: 0,
        bgx: 0.5,
        bgy: 0.5,
        bgc: 'transparent',
        image: false,
    }), state = _b[0], setState = _b[1];
    var background = useRef(null);
    /**
     * parallax
     */
    var parallax = function () {
        // the background and position
        var target = background.current;
        if (target) {
            var targetPos = target.getBoundingClientRect().top;
            // distance to travel
            var dy = window.innerHeight;
            var size = target.offsetHeight;
            // prevent unnecessary state changes
            if (targetPos + target.offsetHeight > 0 &&
                targetPos - target.offsetHeight < dy) {
                // set the background transform to the
                // negative value of the relative
                // position of the image in the viewport
                var bgy_1 = -1 * size * (targetPos / (dy - size));
                setState(__assign(__assign({}, state), { bgy: bgy_1 }));
            }
        }
    };
    useEffect(function () {
        if (data.image) {
            setState(__assign(__assign({}, state), { image: true }));
            parallax();
        }
    }, []);
    useEffect(function () {
        parallax();
    }, [scrollTop]);
    var bgx = state.bgx, bgy = state.bgy, image = state.image;
    return (React.createElement(StyledProject, { className: className },
        image ? (React.createElement(Image, { ref: background },
            React.createElement(Background, { style: {
                    backgroundImage: "url(".concat(data.image, ")"),
                    transform: "translate(".concat(bgx, "px, ").concat(bgy, "px)"),
                } }))) : (''),
        React.createElement(ProjectText, null,
            React.createElement("h3", null,
                data.title,
                " ",
                React.createElement("a", { href: data.url }, "View")),
            React.createElement(Description, null, data.description),
            React.createElement(TagList, null,
                React.createElement(TagLabel, null, "Technologies:"),
                data.tags.map(function (item, index) { return (React.createElement(Tag, { key: index, background: (function () {
                        var col = technologies.find(function (item2) { return item2.name === item; });
                        return col !== undefined ? col.colour : '#bbb';
                    })() }, item)); })))));
};
export default Project;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
